export default __webpack_public_path__ + "static/media/EricY1.cce647ff.png";